export default "__VITE_PUBLIC_ASSET__a7d5f2d3__"